module.exports = __webpack_public_path__ + "img/welding-7.c8fe4fce.jpg";